import type { PropsWithChildren } from 'react';
import { Center, Flex, Box } from '@chakra-ui/react';
import { CopyIcon, tools } from '@halo/ui-chat-react';

function TextWithCopy({ text = '', children }: PropsWithChildren<{ text?: string }>) {
  return (
    <Flex
      alignItems="center"
      gap="1"
      maxW={'full'}
      overflow="hidden"
      css={{
        '&:hover': {
          '--show-copy-name': 'block',
        },
      }}
    >
      <Box flex={1} overflow={'hidden'}>
        {children}
      </Box>
      <Center
        display="var(--show-copy-name, none)"
        cursor="pointer"
        color="fg.muted"
        onClick={() => tools.copyToClipboard(text)}
      >
        <CopyIcon />
      </Center>
    </Flex>
  );
}

export default TextWithCopy;
